import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: 'Inicio', href: '#inicio' },
    { label: 'Nosotros', href: '#nosotros' },
    { label: 'Industrialización', href: '#industrializacion' },
    { label: 'Sustentabilidad', href: '#sustentabilidad' },
    { label: 'Servicios', href: '#servicios' },
    { label: 'Proyectos', href: '#proyectos' },
    { label: 'Contacto', href: '#contacto' }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#inicio" onClick={(e) => scrollToSection(e, '#inicio')} className="flex items-center">
            <img
              src="https://customer-assets.emergentagent.com/job_07d3bd57-1cae-496c-a699-0d97f10cd5ce/artifacts/25bk249o_EDIF%C3%8DSICA.png"
              alt="EDIFÍSICA"
              className="h-12 w-auto"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {menuItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => scrollToSection(e, item.href)}
                className={`text-sm font-medium transition-colors hover:text-[#5E8B7E] ${
                  isScrolled ? 'text-[#4A4A4A]' : 'text-white'
                }`}
              >
                {item.label}
              </a>
            ))}
            <Button
              onClick={(e) => scrollToSection(e, '#contacto')}
              className="bg-[#5E8B7E] hover:bg-[#0A3A48] text-white transition-colors"
            >
              Solicitar Asesoría
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className={isScrolled ? 'text-[#4A4A4A]' : 'text-white'} size={24} />
            ) : (
              <Menu className={isScrolled ? 'text-[#4A4A4A]' : 'text-white'} size={24} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 bg-white/95 backdrop-blur-md rounded-b-lg shadow-lg">
            <nav className="flex flex-col space-y-4">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => scrollToSection(e, item.href)}
                  className="text-[#4A4A4A] hover:text-[#5E8B7E] px-4 py-2 text-sm font-medium transition-colors"
                >
                  {item.label}
                </a>
              ))}
              <div className="px-4">
                <Button
                  onClick={(e) => scrollToSection(e, '#contacto')}
                  className="w-full bg-[#5E8B7E] hover:bg-[#0A3A48] text-white transition-colors"
                >
                  Solicitar Asesoría
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;